export default __webpack_public_path__ + "static/media/ppt.9f13594d.svg";